<template>
  <div class="content">
    <content-header title="お支払い方法について" />
    <div class="content-body">
      以下のお支払い方法をお選びいただけます。
      <div class="for-corporation">
        <div>
          <div class="content-label">法人のお客様</div>
          <div class="content-subtitle">【クロネコ掛け払い】</div>
          <div style="margin-bottom: 20px;">
            法人または個人事業主様の売掛対応にお応えするため、クロネコヤマトの決済サービスを利用した「口座自動振替サービス」のことです。<br />
            &emsp;⦿お支払いは、月末締め翌々月 5 日のまとめて一括払い<br />
            &emsp;⦿ご注文毎のお支払い手続き、現金のご用意が不要<br />
            &emsp;⦿口座振替の場合は手数料無料<br />
            &emsp;⦿即日審査で初回からご利用可能<br />
            &emsp;⦿Web申込みの場合は書類の提出不要（※条件等により必要な場合もございます）<br />

            <p>・ご利用条件</p>
            &emsp;法人・個人事業主のお客様が対象となります。<br />
            &emsp;※所定の審査によりご利用条件等ご希望に添えない場合がありますので、あらかじめご了承ください。

            <p>・ご利用限度額 60 万円</p>
            &emsp;ご利用限度額はご利用からお支払まで（最大 65
            日間）の商品購入累計金額になります。<br />
            &emsp;※60 万円を超えるご利用をご希望の場合はお問い合わせください。

            <p>・クロネコ掛け払いのお支払方法</p>
            &emsp;クロネコ掛け払いについてはコチラをご覧ください。
            <a
              href="https://www.yamato-b2b-pay.com/buy"
              style="font-weight: normal;"
              target="_blank"
            >
              https://www.yamato-b2b-pay.com/buy </a
            ><br />
            <div style="font-weight: bold; margin: 20px 0 5px;">
              &emsp;⦿口座自動振替【口座振替手数料無料】
            </div>
            &emsp;&emsp;ヤマトクレジットファイナンス㈱がお申込みされた口座より引き落とします。<br />
            &emsp;&emsp;締日・支払日：月末締め・翌々月５日支払い（請求書送付日：月末締めの５営業日後に郵送）<br />
            <div style="font-weight: bold; margin: 20px 0 5px;">
              &emsp;⦿銀行振込
            </div>
            &emsp;&emsp;ATM または、銀行窓口よりお振込みいただけます。 <br />
            <div style="font-weight: bold; margin: 20px 0 5px;">
              &emsp;⦿コンビニ支払い
            </div>
            &emsp;&emsp;コンビニからお支払いいただけます。<br />
          </div>
        </div>
      </div>
      <div class="for-individual">
        <div style="display: flex;">
          <div class="content-label" style="margin-right: 10px;">
            法人のお客様
          </div>
          <div class="content-label">個人のお客様</div>
        </div>
        <div style="margin-bottom: 30px;">
          <div class="content-subtitle">
            【クロネコWEBコレクト（注文時クレジットカード決済）】
          </div>
          クロネコ web
          コレクトとはクロネコヤマトのクレジットカード決済サービスです。<br />
          クロネコ web
          コレクトにつきましては「ヤマトフィナンシャル株式会社」またはクロネコ
          web コレクト【クレジットカード払い】をご覧ください。
          <div class="content-circle">
            ■ ヤマトフィナンシャル株式会社
            <a href="https://www.yamatofinancial.jp/" target="_blank">
              https://www.yamatofinancial.jp/
            </a>
            <br />
            ■ クロネコ web コレクト【クレジットカード払い】
            <a
              href="https://www.yamatofinancial.jp/consumer/payment/credit_card.html"
              target="_blank"
              style="overflow-wrap: anywhere;"
            >
              https://www.yamatofinancial.jp/consumer/payment/credit_card.html
            </a>
          </div>

          <p>・お支払いは、商品が宅急便で出荷されてから確定されるので安心</p>
          <div style="margin-left: 15px;">
            クロネコwebコレクトでクレジットカードによるお支払い手続き受付完了後、クロネコヤマトから確認の
            e メールをご購入者様宛に送信いたします。<br />
            その後、商品の出荷をクロネコヤマトが確認してから、クロネコ web
            コレクトよりクレジットカード会社にご請求の手続きを依頼しますので、<br />
            発送前に代金の請求がなされることはありません。
          </div>

          <p>・クレジットカードの情報は当社に連絡されないので安心</p>
          <div style="margin-left: 15px;">
            クロネコwebコレクトの画面に入力されたご購入者様のクレジットカードの番号情報等は、クロネコヤマトから当社に連絡されることはありません。<br />
            もちろんクロネコヤマトでもご購入者様のクレジットカードの情報については見ることができません。<br />
            また、システムのセキュリティについても各クレジットカード会社の承認を得ており、<br />
            クレジットカードの情報も暗号化（SSL）して送信されますのでご安心ください。
          </div>

          <p>・クロネコ web コレクト クレジットカード決済の流れ</p>
          <div style="margin-left: 15px;">
            <div class="content-circle">
              ①ご注文時にお支払い方法でクレジットカードお支払いをお選びください。
            </div>
            <div class="content-flow-arrow">▼</div>
            <div class="content-circle">
              ②ご注文内容を確認後、ヤマトファイナンシャル㈱より決済依頼メールが届きますので、<br />
              &emsp;メールに記載されたお支払い手続き画面のURLにアクセスし、お支払手続きを行ってください。<br />
              &emsp;※当社にもクロネコヤマトにもお客様のカード情報が残らない安心の決済方法です。<br />
              &emsp;※クレジットカード情報入力画面は情報も暗号化（SSL）で保護されています。
            </div>
            <div class="content-flow-arrow">▼</div>
            <div class="content-circle">
              ③クレジットカードでの決済確認後、商品発送の手配をさせていただきます。
            </div>
          </div>

          <p>・ご利用可能なクレジットカード</p>
          <div style="margin-left: 15px;">
            <div class="credit-cards">
              <img v-lazy="'/static/guide/guide_01.png'" />
              <img v-lazy="'/static/guide/guide_02.png'" />
              <img v-lazy="'/static/guide/guide_03.png'" />
              <img v-lazy="'/static/guide/guide_04.png'" />
            </div>
            JCB、VISA、master、ダイナースのマークが入っているカードはすべてご利用いただけます。
          </div>
        </div>
        <div style="margin-bottom: 30px;">
          <div class="content-subtitle">
            【宅急便代金引換】
          </div>
          商品お届けの際に運送会社へ商品代金を現金でのお支払いの他、複数のクレジットカードやデビットカードでの決済が可能です。<br />
          &emsp;⦿代金引換（お届け時現金払い）<br />
          &emsp;⦿お届け時クレジットカード払い<br />
          &emsp;※代引き手数料及びカード支払い手数料は当社が負担します。<br />
          代金引換のお支払い方法について詳しくは下記をご覧ください。
          <div class="content-circle">
            <div>
              ■ ヤマト運輸 宅急便コレクト<br />
              【代金引換（お届け時現金払い）】
              <a
                href="https://www.yamatofinancial.jp/consumer/payment/daibiki.html"
                target="_blank"
                style="overflow-wrap: anywhere;"
              >
                https://www.yamatofinancial.jp/consumer/payment/daibiki.html
              </a>
            </div>
            <div style="margin-top: 20px;">
              <div>
                ■ 佐川急便 e- コレクト ®<br />
                【代金引換 / カード決済】
              </div>
              <a
                href="https://www.sg-financial.co.jp/e-collect/"
                target="_blank"
                style="overflow-wrap: anywhere;"
              >
                <img
                  v-lazy="'/static/guide/e-collect.gif'"
                  style="width: 100%;"
                />
                <br />
                https://www.sg-financial.co.jp/e-collect/
              </a>
            </div>
          </div>
        </div>
        <div style="margin-bottom: 30px;">
          <div class="content-subtitle">
            【前払い銀行振込】
          </div>
          ご注文内容を確認後、お振込み先のご案内をさせていただきます。<br />
          ご注文後、1週間以内にお振込みください。1週間を超えた場合は、誠に勝手ながら無効とさせていただきます。
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContentHeader from '@/components/modules/ContentHeader'

export default {
  components: {
    ContentHeader,
  },
}
</script>

<style scoped>
.content-body p {
  font-weight: bold;

  margin: 20px 0 5px;
}

.content-body .for-corporation p {
  color: rgb(80, 172, 252);
}

.for-corporation,
.for-individual {
  margin-bottom: 40px;
}

.content-flow-arrow {
  font-size: 8px;

  width: 100%;
  padding: 2px 0;

  text-align: center;
}

.credit-cards {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  padding: 20px;

  border: 1px solid rgb(160, 179, 188);
  border-radius: 4px;
}

.credit-cards img {
  align-self: center;

  width: 60px;
  height: auto;
  margin: 0 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/modules/guide/AboutPayment.vue